<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex sm8 md6 lg5>
  <v-form @submit.prevent="saveRace" novalidate class="elevation-2 pa-3 race-form">
          <input-date
              v-model="race.race_date"
              label="Data"
              :error="hasErrors('race_date')"
              :error-messages="getErrors('race_date')"
          >
          </input-date>
          <v-text-field
              v-model="race.name"
              label="Nazwa"
              :error="hasErrors('name')"
              :error-messages="getErrors('name')"
          >
            <i slot="prepend" v-tooltip="'Nazwa'" class="text-icon">N</i>
          </v-text-field>
          <v-text-field
              v-model="race.city"
              label="Miasto"
              :error="hasErrors('city')"
              :error-messages="getErrors('city')"
          >
            <v-icon slot="prepend" v-tooltip="'Miasto'">location_city</v-icon>
          </v-text-field>
              <v-select
                v-model="race.race_type"
                :items="allRaceTypesStringsOptions"
                label="Rodzaj"
                :error="hasErrors('race_type')"
                :error-messages="getErrors('race_type')"
                @change="changeRaceType"
              >
                <i slot="prepend" v-tooltip="'Rodzaj'" class="text-icon">R</i>
              </v-select>
          <v-select
              v-if="['street', 'track'].indexOf(race.race_type) > -1"
              v-model="race.distance_string"
              label="Dystans"
              :items="distanceOptions"
              :error="hasErrors('distance_string')"
              :error-messages="getErrors('distance_string')"
          >
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
          </v-select>
          <v-text-field
              v-if="['other', 'ultra'].indexOf(race.distance_string) > -1"
              v-model="race.distance_km"
              label="Dystans w kilometrach"
              :error="hasErrors('distance_km')"
              :error-messages="getErrors('distance_km')"
          >
            <i slot="prepend" v-tooltip="'Dystans w kilometrach'" class="fi flaticon-road-1"></i>
          </v-text-field>
          <v-checkbox
            v-if="race.race_type === 'street'"
            label="Atest"
            v-model="race.certified"
            :error="hasErrors('certified')"
            :error-messages="getErrors('certified')"
            >
            <v-icon slot="prepend" v-tooltip="'Atest'">spellcheck</v-icon>
          </v-checkbox>
          <v-select
              label="Priorytet"
              v-model="race.priority"
              :items="allRacePrioritiesOptions"
              :error="hasErrors('priority')"
              :error-messages="getErrors('priority')"
              dense
          >
            <i slot="prepend" v-tooltip="'Priorytet'" class="text-icon">P</i>
          </v-select>
      <v-textarea
          v-model="race.trainer_remarks"
          label="Informacje dodatkowe"
          :error="hasErrors('trainer_remarks')"
          :error-messages="getErrors('trainer_remarks')"
          auto-grow
          box
      >
        <v-icon slot="prepend" v-tooltip="'Informacje dodatkowe'">info</v-icon>
      </v-textarea>
      <v-btn type="submit" color="primary">Zapisz</v-btn>
      </div>
    </div>
  </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {createRace, updateRace} from '../plan/api'
import { mapGetters } from 'vuex'
import iziToast from 'izitoast'
import InputDate from '@/forms/InputDate'

export default {
  components: {InputDate},
  props: {
    raceData: {
      type: Object,
      default: function () {
        return {
          distance_string: null,
          priority: 'B'
        }
      }
    }
  },
  data () {
    return {
      errors: {},
      race: {}
    }
  },
  computed: {
    ...mapGetters([
      'allRaceTypesStringsOptions', 'raceDistanceStreetStringsOptions',
      'allRaceDistanceStringsOptions', 'raceDistanceTrackStringsOptions',
      'allRacePrioritiesOptions', 'runner'
    ]),
    isNew () {
      return this.race.id === undefined
    },
    distanceOptions () {
      if (this.race.race_type === 'street') {
        return this.raceDistanceStreetStringsOptions
      }
      if (this.race.race_type === 'track') {
        return this.raceDistanceTrackStringsOptions
      }
      return [
        {
          text: 'inne',
          value: 'other'
        }
      ]
    }
  },
  created () {
    this.initRace()
  },
  methods: {
    initRace () {
      this.race = {...this.raceData}
    },
    changeRaceType () {
      if (this.race.race_type !== 'street' && this.race.race_type !== 'track') {
        this.race.distance_string = 'other'
      } else {
        this.race.distance_string = null
      }
    },
    saveRace () {
      if (this.isNew) {
        var promise = createRace(this.runner, this.race).then((data) => {
          this.$emit('success', data)
          iziToast.show({
            message: 'Zawody zostały dodane',
            color: 'green'
          })
          return data
        })
      } else {
        promise = updateRace(this.runner, this.race).then((data) => {
          this.$emit('success', data)
          iziToast.show({
            message: 'Zawody zostały zmienione',
            color: 'green'
          })
          return data
        })
      }
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/races/RaceForm.vue